module.exports = __webpack_public_path__ + "static/media/Sewaddle_gaussian2.5993fba1.png";